import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { JPYs, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { WorkType } from '../common/enums';
import { BlankTypes } from '../common/Constant';

const IQ3KouteiBetsuKesanshiki_MenualBari = (props) => {
  const basicSetupTimeSec = props?.deviceMst?.details?.prepBasicTime;

  //装置の作業時間チャージ
  const mWorkHRate = props?.deviceMst.details?.charges.work;

  //装置の段階時間チャージ
  const mSetHRate = props?.deviceMst.details?.charges.prep;

  const dandoriAmt = (basicSetupTimeSec * mSetHRate) / 3600;

  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const isOutDetailOpen = openInputSubDetailKeys.has('kakou-detail-out');

  const isInDetailOpen = openInputSubDetailKeys.has('kakou-detail-in');

  const [productionQuantityCoeff, setProductionQuantityCoeff] = useState(0);

  // 外周作業
  const [outSpeed, setOutSpeed] = useState(0);
  const [outLen, setOutLen] = useState(0);
  const [outCount, setOutCount] = useState(0);
  const [outProcessTime, setOutProcessTime] = useState(0);
  const [outProcessAmt, setOutProcessAmt] = useState(0);

  // 内周作業
  const [inSpeed, setInSpeed] = useState(0);
  const [inLen, setInLen] = useState(0);
  const [inCount, setInCount] = useState(0);
  const [inProcessTime, setInProcessTime] = useState(0);
  const [inProcessAmt, setInProcessAmt] = useState(0);

  useEffect(() => {
    // レーザー工程入力情報取得
    let processInput = props?.menualBariData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];
    // if (processInput) {
    //   setLaserProcessInput(processInput);
    // }

    calculateOutCutProcessing();
  }, [props?.menualBariData]);

  const calculateOutCutProcessing = () => {
    // 手動バリ工程入力情報取得
    let manualDeburProcessInput = props?.menualBariData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];

    let productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);
    setProductionQuantityCoeff(productionQuantityCoeff);

    let cSagyoTimeOutSec = 0;
    let cSagyoAmtOut = 0;

    // 外周切断長
    let outCutLen = Number(manualDeburProcessInput?.details?.[0]?.length);
    setOutLen(outCutLen);
    let outCutProcessCount = Number(manualDeburProcessInput?.details?.[0]?.count);
    setOutCount(outCutProcessCount);

    // 内周切断長
    let inCutLen = Number(manualDeburProcessInput?.details?.[1]?.length);
    setInLen(inCutLen);
    let inCutProcessCount = Number(manualDeburProcessInput?.details?.[1]?.count);
    setInCount(inCutProcessCount);

    // 外周作業時間(外周切断長	/	加工速度)＊生産個数係数
    if (outCutLen !== 0 && outCutProcessCount !== 0) {
      let cSagyoSpeed = getSpeedLenTime(props?.deviceMst);
      setOutSpeed(cSagyoSpeed);
      let xOut = Number.isFinite(outCutLen / cSagyoSpeed) ? outCutLen / cSagyoSpeed : 0;
      let cSagyoTimeOutPerSec = xOut * outCutProcessCount * 60;
      cSagyoTimeOutSec = cSagyoTimeOutPerSec * productionQuantityCoeff; // IQX_WEBEST-278 加工時間＊生産個数係数]
      setOutProcessTime(cSagyoTimeOutSec);

      // 作業金額
      //　作業時間＊時間チャージ
      cSagyoAmtOut = calSagyoAmt(cSagyoTimeOutSec);
      setOutProcessAmt(cSagyoAmtOut);
    }

    //

    let cSagyoTimeInSec = 0;
    let cSagyoAmtIn = 0;
    // 作業時間{(内周切断長	/	加工速度	＊	加工速度係数)	+	(加工補正時間	*	加工補正係数)｝	*	サイズ係数	*	回数
    // 加工速度
    // 指定された内径最小矩形周長より手動バリ対象かチェック
    let rectangleDia = props?.deviceMst?.details?.rectangleDia ? props?.deviceMst?.details?.rectangleDia : 0;
    let roundHoleDia = props?.deviceMst?.details?.roundHoleDia ? props?.deviceMst?.details?.roundHoleDia : 0;
    let cSagyoSpeedIn = 0;
    // チェックを入れると左で設定した数値以上だったときに、矩形内にある穴にバリ取りを行う
    let rectangleBariOnFlg = props?.deviceMst?.details?.rectangleBariOnFlg
      ? props?.deviceMst?.details?.rectangleBariOnFlg
      : false;

    let blankProcessId = 0;
    let blankProcessMst = props?.parameters?.process
      ? props?.parameters.process?.filter((item) => item.workType === WorkType.SmBlankCombi)[0]
      : [];
    let blankPatternInfo = props?.menualBariData?.processSelect
      ? props?.menualBariData?.processSelect?.details?.filter(
          (item) => item.processId == blankProcessMst?.id && item.isUsedForCalc
        )
      : [];
    if (blankPatternInfo && blankPatternInfo?.length > 0) {
      blankProcessId = blankPatternInfo?.[0]?.processId;
    }
    blankProcessMst = props?.parameters?.process
      ? props?.parameters.process?.filter((item) => item.workType === WorkType.SmBlankPunch)[0]
      : [];
    blankPatternInfo = props?.menualBariData?.processSelect
      ? props?.menualBariData?.processSelect?.details?.filter(
          (item) => item.processId == blankProcessMst?.id && item.isUsedForCalc
        )
      : [];
    if (blankPatternInfo && blankPatternInfo?.length > 0) {
      blankProcessId = blankPatternInfo?.[0]?.processId;
    }
    blankProcessMst = props?.parameters?.process
      ? props?.parameters.process?.filter((item) => item.workType === WorkType.SmBlankLaser)[0]
      : [];
    blankPatternInfo = props?.menualBariData?.processSelect
      ? props?.menualBariData?.processSelect?.details?.filter(
          (item) => item.processId == blankProcessMst?.id && item.isUsedForCalc
        )
      : [];
    if (blankPatternInfo && blankPatternInfo?.length > 0) {
      blankProcessId = blankPatternInfo?.[0]?.processId;
    }

    let blankProcessInput = props?.menualBariData?.processInput?.filter(
      (item) => item.processId == blankProcessId
    )?.[0];

    if (rectangleBariOnFlg) {
      let processInputBlankTypes = blankProcessInput?.details?.[0]?.quantityList;
      let targetBariInCutLen = 0;
      for (let i = 0; i < processInputBlankTypes?.length; i++) {
        let blankTypeNm = BlankTypes?.filter((t) => t.id == processInputBlankTypes[i]?.types)?.[0]?.label;
        // 長角の場合、パラメータの最小内径矩形周長より大きいの場合、バリ取りをする。
        if (
          (blankTypeNm == '角' || blankTypeNm == '長角') &&
          rectangleDia <= Number(processInputBlankTypes[i]?.perimeter)
        ) {
          targetBariInCutLen += Number(processInputBlankTypes[i]?.perimeter);
        } else if (blankTypeNm == '丸' && roundHoleDia <= Number(processInputBlankTypes[i]?.diameter)) {
          targetBariInCutLen += Number(processInputBlankTypes[i]?.perimeter);
        }
      }

      // 加工速度を取得
      cSagyoSpeedIn = getSpeedLenTime(props?.deviceMst);
      setInSpeed(cSagyoSpeedIn);
      // 加工速度係数を取得
      let workSpeedCoeffLengthThMasterIn = props?.deviceMst?.details?.workSpeedCoeffLengthThMaster?.filter(
        (item) => (item.value == thickness || item.value > thickness) && !item.isOutOfRange
      );
      let cSagyoSpeedInCoef = props?.deviceMst?.details?.workSpeedCoeffInternalWorkItems?.filter(
        (item) => item.no == workSpeedCoeffLengthThMasterIn?.[0]?.no && !item.isOutOfRange
      )?.[0]?.value;

      if (targetBariInCutLen !== 0 && inCutProcessCount !== 0) {
        // 内周作業時間(内周切断長	/	加工速度)＊生産個数係数
        let xIn = Number.isFinite(targetBariInCutLen / cSagyoSpeedIn)
          ? (targetBariInCutLen / cSagyoSpeedIn) * cSagyoSpeedInCoef
          : 0;
        let cSagyoTimeInPerSec = xIn * inCutProcessCount * 60;
        cSagyoTimeInSec = cSagyoTimeInPerSec * productionQuantityCoeff; // IQX_WEBEST-278 加工時間＊生産個数係数
        setInProcessTime(cSagyoTimeInSec);

        // 作業金額
        //　作業時間＊時間チャージ
        cSagyoAmtIn = calSagyoAmt(cSagyoTimeInSec);
        setInProcessAmt(cSagyoAmtIn);
      }
    }
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.menualBariData?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const calSagyoAmt = (cSagyoTimeKonpoSec) => {
    // 作業金額
    // 作業時間
    let mWorkHTime = cSagyoTimeKonpoSec;
    let mWorkHTimeMin = Number.isFinite(mWorkHTime / 60) ? mWorkHTime / 60 : 0;
    //　加工時間＊時間チャージ
    let cSagyoAmtKonpo = Number.isFinite((mWorkHTimeMin * mWorkHRate) / 60.0) ? (mWorkHTimeMin * mWorkHRate) / 60.0 : 0;
    cSagyoAmtKonpo = cSagyoAmtKonpo ? cSagyoAmtKonpo : 0;
    return cSagyoAmtKonpo;
  };

  const getSpeedLenTime = (deviceMst) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;

    let partsCoeff = deviceMst?.details?.workSpeed ? deviceMst?.details?.workSpeed : 0;
    return partsCoeff;
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>
        </Col>
        <Col span={12} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
          </div>
        </Col>
        <Col span={8} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${basicSetupTimeSec} (${secondsToHms(basicSetupTimeSec)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${basicSetupTimeSec} × ${mSetHRate}) ÷ 3600 = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
          </div>
        </Col>
      </Row>

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'out')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isOutDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'外周加工金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isOutDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周加工速度'}</label>
                </div>

                <div>
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'(外周切断長 / 加工速度) x 外周切断長 x 60 x 生産個数係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周加工速度'}</label>
                </div>

                <div>
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`$(${outLen} / ${outSpeed}) x ${outCount} x 60 x ${productionQuantityCoeff} = ${outProcessTime} (${secondsToHms(
                    outProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outProcessTime} × ${mWorkHRate} = ${JPYs.format(Math.round(outProcessAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outLen}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'in')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isInDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'内周加工金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isInDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'(外周切断長 / 加工速度) x 外周切断長 x 60 x 生産個数係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`$(${inLen} / ${inSpeed}) x ${inCount} x 60 x ${productionQuantityCoeff} = ${inProcessTime} (${secondsToHms(
                    inProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inProcessTime} × ${mWorkHRate} = ${JPYs.format(Math.round(inProcessAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inLen}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_MenualBari;
